export const SUCCESS_FETCH_COMPANY_TYPE = 'SUCCESS_FETCH_COMPANY_TYPE';
export const FAIL_FETCH_COMPANY_TYPE = 'FAIL_FETCH_COMPANY_TYPE';
export const SUCCESS_FETCH_COMPANY = 'SUCCESS_FETCH_COMPANY';
export const FAIL_FETCH_COMPANY = 'FAIL_FETCH_COMPANY';
export const SUCCESS_FETCH_PURCHASING_ORG = 'SUCCESS_FETCH_PURCHASING_ORG';
export const FAIL_FETCH_PURCHASING_ORG = 'FAIL_FETCH_PURCHASING_ORG';
export const SUCCESS_FETCH_COUNTRY = 'SUCCESS_FETCH_COUNTRY';
export const FAIL_FETCH_COUNTRY = 'FAIL_FETCH_COUNTRY';
export const SUCCESS_FETCH_REGION = 'SUCCESS_FETCH_REGION';
export const FAIL_FETCH_REGION = 'FAIL_FETCH_REGION';
export const SUCCESS_FETCH_DISTRICT = 'SUCCESS_FETCH_DISTRICT';
export const FAIL_FETCH_DISTRICT = 'FAIL_FETCH_DISTRICT';
export const SUCCESS_FETCH_VILLAGE = 'SUCCESS_FETCH_VILLAGE';
export const FAIL_FETCH_VILLAGE = 'FAIL_FETCH_VILLAGE';
export const SUCCESS_FETCH_VENDOR_TYPE = 'SUCCESS_FETCH_VENDOR_TYPE';
export const FAIL_FETCH_VENDOR_TYPE = 'FAIL_FETCH_VENDOR_TYPE';
export const SUCCESS_SAVE_VENDOR = 'SUCCESS_SAVE_VENDOR';
export const FAIL_SAVE_VENDOR = 'FAIL_SAVE_VENDOR';
export const SUCCESS_FETCH_POSTCAL_CODE = 'SUCCESS_FETCH_POSTCAL_CODE';
export const FAIL_FETCH_POSTCAL_CODE = 'FAIL_FETCH_POSTCAL_CODE';
export const SUCCESS_FETCH_SUB_DISTRICT = 'SUCCESS_FETCH_SUB_DISTRICT';
export const FAIL_FETCH_SUB_DISTRICT = 'FAIL_FETCH_SUB_DISTRICT';
export const SUCCESS_FETCH_TENDER_UMUM = 'SUCCESS_FETCH_TENDER_UMUM';
export const FAIL_FETCH_TENDER_UMUM = 'FAIL_FETCH_TENDER_UMUM';
export const SUCCESS_FETCH_JENIS_PEMODALAN = 'SUCCESS_FETCH_JENIS_PEMODALAN';
export const FAIL_FETCH_JENIS_PEMODALAN = 'FAIL_FETCH_JENIS_PEMODALAN';
